export const isMobileDevice = () => {


    return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) || isIOS();
}

export function isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    } else {
        return navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform);
    }
}

export const isAppleDevice = () => {
    return /iPad|iPhone|iPod/.test(navigator.platform) || /MacIntel/.test(navigator.platform);
}